import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import About from './About';
import curvyAarya2 from './assets/curvyAarya2.png';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <Navbar />
      <main className="flex-grow text-white flex flex-col items-center justify-start pt-20">
        <h2 className="text-2xl translate-x-8 md:-translate-x-16 lg:-translate-x-32">Hi! It's</h2>
        <img src={curvyAarya2} alt="Aarya" className="w-auto h-auto mb-4 scale-[0.75]" />
        <div className="h-[20px]"></div>
        <p className="text-center mb-2">I'm a computer engineering student at Texas A&M.</p>
        <p className="text-center mb-6">I like to build aesthetic and efficient tools.</p>
        <button className="bg-gray-300 text-gray-800 px-6 py-2 rounded-lg hover:bg-gray-400 transition">
          <Link to="/about">Learn More</Link>
        </button>
      </main>
      <Footer />
    </div>
  );
}

export default Home;

